import React, { useEffect, useState } from "react";
import AllCtx from "../../uti-functions/allCtx";

function InfantDetails() {
  const {
    // monitor,
    adult,
    children,
    infant,
    allPassengers,

    tripType,
    flightArray,
    setTheFlightArray,
    chosenFlight,
    chosenFlightID,
    setTheChosenClass,
    setTheChosenClassPrice,
    chosenClass,
    chosenClassName,
    chosenClassPrice,
    setTheChosenFlight,
    setTheChosenFlightID,
    searchBookingResponse,
    setTheSearchBookingResponse,
    setTheChosenClassName,
    setTheClassChosen,
    classChosen,
    setTheSearchResultResponse,
    searchResultResponse,
    setTheAllPassengers,
    setTheInfantArray,
    adultArray,
    childrenArray,
    infantArray, 
    setTheAdultArray
  } = AllCtx();

  useEffect(() => {
    if (localStorage.getItem("infantArray")) {
      setTheInfantArray(JSON.parse(localStorage.getItem("infantArray")));
  }
}, [])

  const [infantTitle, setInfantTitle] = useState("");
  const [infantGender, setInfantGender] = useState("");
  const [infantFirstName, setInfantFirstName] = useState("");
  const [infantLastName, setInfantLastName] = useState("");
  const [infantDOB, setInfantDOB] = useState("");

  const [monitor, setMonitor] = useState(true);



 

  return (
    <div>
      {infantArray.map((infant) => (
        <div key={infant.id} className="mt-10">
          <div>
            <p className="text-pry-color mb-2 font-semibold">
              {
                 `${infant.id} Details`}
            </p>
          </div>

          <div className=" border-2 rounded-md py-4 px-2 sm:px-5 md:px-2">
            <div className="mb-2">
              <p className="font-semibold text-sm">Passenger Info</p>
            </div>
           
           
           
            <div className="flex">
              <div className="w-20">
                <p>NAME: </p>
              </div>{" "}
              <div>
                <p><span>{infant.title.toUpperCase()}</span> <span>{infant.first_name.toUpperCase()}</span> <span>{ infant.last_name.toUpperCase()}</span></p>
              </div>
            </div>

            <div className="flex">
              <div className="w-20">
                <p>GENDER: </p>
              </div>{" "}
              <div>
                <p>{infant.gender.toUpperCase()} </p>
              </div>
            </div>

        
          </div>
        </div>
      ))}
    </div>
  );
}

export default InfantDetails;
